export default __webpack_public_path__ + "static/media/titleicon5.ba5b1d31.svg";